import { GiftCardRedemptionComponentModule } from '@b2b/common/components/gift-card-redemption';
import { ReservationInputComponentModule } from '@b2b/common/components/reservation-input';
import { PaymentDirectiveModule } from '@b2b/common/directives';
import { LoadACMECheckoutResolver, ThemesDataResolver } from '@b2b/common/resolvers';
import { ApiService } from '@b2b/common/services/api/types';
import uiRouter, { StateParams, StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsListAdminBookingControllerModule } from './controllers/ProgramsListAdminBookingController';

export const ProgramsListAdminBookingView = angular
  .module('acme.view.application.programs.list.admin.booking', [
    uiRouter,
    'ui.bootstrap',
    PaymentDirectiveModule,
    'acme.common.directive.integer',
    ReservationInputComponentModule,
    GiftCardRedemptionComponentModule,
    ProgramsListAdminBookingControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.programs.listAdminBooking',
      url: '/booking/:id?orderId',
      views: {
        'subview-main': {
          controller: 'ProgramsListAdminBookingController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/list/admin/booking/booking.tpl.html',
        },
      },
      data: {
        pageTitle: 'Re-book Order',
        permissions: ['ORDER_REBOOK'],
      },
      resolve: {
        EventData: [
          '$stateParams',
          'ApiService',
          function ($stateParams: StateParams, ApiService: ApiService) {
            return ApiService.program.instances.detail($stateParams.id);
          },
        ],
        ThemesData: ThemesDataResolver({ includeEmail: true }),
        ACMECheckout: LoadACMECheckoutResolver(),
      },
    });
  }).name;
